import { render, staticRenderFns } from "./MarketingSetting.vue?vue&type=template&id=1d678785"
import script from "./MarketingSetting.vue?vue&type=script&lang=js"
export * from "./MarketingSetting.vue?vue&type=script&lang=js"
import style0 from "./MarketingSetting.vue?vue&type=style&index=0&id=1d678785&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports